import React from "react"
import {FinAidNoticeFilter, FinAidNoticeTable} from "./parts"

type State = {
    filterObject: any
    isSubmitFilter: boolean
    activeTabKey: string
    filterFormSearch: string
}

type Props = {
    studentId
    activeTabKey
}

class FinanicalAidStudentTabNotesTab extends React.Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            filterObject: {},
            filterFormSearch: "",
            isSubmitFilter: false,
            activeTabKey: props.activeTabKey
        }
    }

    public onChangeFilter = async () => {
        this.setState({isSubmitFilter: true})
    }

    public onChangeFilterComplete = async () => {
        this.setState({isSubmitFilter: false})
    }

    public updateFilter = (filterData) => {
        this.setState({
            filterObject: {
                ...this.state.filterObject,
                ...filterData
            }
        })
    }

    public onClearFilter = () => {
        this.setState({filterObject: {}})
    }

    render() {
        const {filterObject, isSubmitFilter, filterFormSearch} = this.state

        return (
            <div>
                <FinAidNoticeFilter
                    onChangeFilter={this.onChangeFilter}
                    updateFilter={this.updateFilter}
                    onClearFilter={this.onClearFilter}
                    filterObject={filterObject}
                    setFilterFormSearch={(value) => this.setState({filterFormSearch: value})}
                />
                <FinAidNoticeTable
                    filterObject={filterObject}
                    filterFormSearch={filterFormSearch}
                    isSubmitFilter={isSubmitFilter}
                    onChangeFilterComplete={this.onChangeFilterComplete}
                    {...this.props}
                />
            </div>
        )
    }
}

export default FinanicalAidStudentTabNotesTab
